const baseColors = {
  // Teal
  teal100: '#008a94',
  teal200: '#007078',

  // primary
  primary100: '#E6F4F5',
  primary200: '#9ED6DB',

  secondary900: '#040815',

  // Gray
  white: '#ffffff',
  gray100: '#F6F6F6',
  gray150: '#EBEBEC',
  gray200: '#E0E1E2',
  gray300: '#C1C3C5',
  gray400: '#ABAEB1',
  gray500: '#8C9093',
  gray600: '#6D7176',
  gray700: '#585D62',
  gray800: '#43494F',
  gray900: '#2E343B',
  black: '#191E23',
  grayBlack: '#191E23',

  // Sementic
  red100: '#F14840',
  red200: '#FFDDD8',
  red400: '#F14840',

  green200: '#CDEBCC',
  green400: '#43CA5C',
  green500: '#30A050',

  blue100: '#1A7AD0',
  blue400: '#4A81D5',
  blue500: '#3F72D4',

  yellow500: '#FFC700',

  shadow01: '#2c2c2c33',
};

const textColors = {
  textPrimary: baseColors.gray800,
  textSecondary: baseColors.gray600,
  placeholder: baseColors.gray300,
  disabled: baseColors.gray300,
  linkPrimary: baseColors.blue400,
};

export const palette = {
  ...baseColors,
  ...textColors,
  bgGray100: baseColors.gray100,
  bgTeal100: baseColors.primary100,
  primary400: baseColors.teal100,
  primary500: baseColors.teal200,
};
